// @ts-nocheck
import constants from "@store/constants";
import { getBuiltQueryString, QueryString } from "@store/Framework/Common/Utilities/getBuildQueryString";

export type SupportLinkIntent = "pricing" | "leadTime";

export const supportTooltipMessageKeys = {
    zeroPriceUpdatedPrice: "ZeroPrice_ContactSupportTooltip",
};

const supportPageTypesByIntent: Record<SupportLinkIntent, string> = {
    pricing: constants.pageType.salesSupport,
    leadTime: constants.pageType.shippingSupport,
};

export interface ResolveSupportLinkParameter {
    pageUrl?: string | null;
    productId?: string | null;
}

export const getSupportPageType = (intent: SupportLinkIntent) => supportPageTypesByIntent[intent];

export const resolveSupportLink = ({ pageUrl, productId }: ResolveSupportLinkParameter): string | undefined => {
    if (!pageUrl) {
        return undefined;
    }

    if (!productId) {
        return pageUrl;
    }

    const queryString: QueryString[] = [{ [constants.queryStringParameters.referenceProductId]: productId }];

    return getBuiltQueryString(pageUrl, queryString) ?? pageUrl;
};
